import React, {Component} from 'react';
import {NavLink} from 'components/ReactRouterDomLocalized';

import paths from 'paths';

import 'sass/headers/header.scss';

import {dt} from 'l10n';

class HeaderNotification extends Component {

    constructor(props) {
        super(props);

        this.state = {}
    }

    render() {
        let {title, showForm = true} = this.props;

        return (
            <header className="follow-header">
                <div className="content">
                    <h1>{title}</h1>
                    <div className="text-follow-header">
                        <div>{dt( 'notifications','Here you can see all notifications or choose what notifications you want to receive. Or do not receive anything at all.')}</div>
                        <div className="choose-follow">
                            <NavLink to={paths.memberNotificationList.path} className="choose-f" activeClassName="active">
                                <span>{dt('notifications', 'Notifications')}</span>
                            </NavLink>
                            <NavLink to={paths.memberNotificationSetting.path} className="choose-f" activeClassName="active">
                                <span>{dt('notifications','Settings')}</span>
                            </NavLink>
                        </div>
                    </div>
                </div>
            </header>
        )
    }
}

export default HeaderNotification;


// WEBPACK FOOTER //
// ./src/components/notification/HeaderNotification.js